import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import moment from 'moment'
import { fetchSubjectByToken, verifyConferenceExpiryDate } from 'store/subject'

const useTokenValidation = () => {
  const location = useLocation()
  const token = new URLSearchParams(location.search).get('token')
  const dispatch = useDispatch()
  const { subject, inProgress } = useSelector((state) => state.subjects)
  const { conference } = useSelector((state) => state.conference)

  let isConfExpired = true

  if (conference?.id) {
    const todayDate = moment().startOf('day')
    const expiryDate = moment(conference?.endDate).startOf('day')
    isConfExpired = todayDate.isAfter(expiryDate)
  }

  useEffect(() => {
    if (token) {
      dispatch(fetchSubjectByToken(token))
    }
  }, [dispatch, token])

  useEffect(() => {
    if (subject?.conferenceId) {
      dispatch(verifyConferenceExpiryDate(subject?.conferenceId))
    }
  }, [dispatch, subject?.conferenceId])

  if (inProgress) {
    return {
      isLoading: true,
      isTokenValid: true,
      token
    }
  } else if (token !== subject?.token || isConfExpired) {
    return {
      isLoading: false,
      isTokenValid: false,
      token
    }
  } else {
    return {
      isLoading: false,
      isTokenValid: true,
      token
    }
  }
}

export default useTokenValidation
